import { watch } from 'vue';
import AbstractStore from '@common/store/AbstractStore';

interface ReferentialVersionState {
  version: string|null;
  known: boolean;
}

// Version du référentiel renvoyée par /api/me : les stores chargés au démarrage l'attendent
// pour savoir si leur copie en cache local est encore valable.
class ReferentialVersion extends AbstractStore<ReferentialVersionState> {
  protected data(): ReferentialVersionState {
    return {
      version: null,
      known: false,
    };
  }

  protected initialize(): void {
    this.setInitialized(true);
  }

  public get isExpected(): boolean {
    return document.querySelector('meta[name="auth"]')?.getAttribute('content') === '1'
      && !document.querySelector('#app')?.classList.contains('customer');
  }

  public set(version: string|null): void {
    this.state.version = version;
    this.state.known = true;
  }

  public reset(): void {
    this.state.version = null;
    this.state.known = false;
  }

  public whenKnown(): Promise<string|null> {
    if (this.state.known) {
      return Promise.resolve(this.state.version);
    }

    return new Promise((resolve) => {
      const stop = watch(() => this.state.known, (known) => {
        if (known) {
          stop();
          resolve(this.state.version);
        }
      });
    });
  }
}

export default new ReferentialVersion();
